// extracted by mini-css-extract-plugin
export var infoItem = "_o4-2";
export var title = "_o4-0";
export var value = "_o4-1";